export { default as ITeroTermsAndConditions } from './ITeroTermsAndConditions';
export * as Styled from './ITeroTermsAndConditions.styles';
